<template>
  <div class="register-container">
    <el-form class="register-form" :model="form" :rules="rules" ref="formRef" label-width="80px">
      <h2 class="register-title">用户注册</h2>

      <!-- 用户名 -->
      <el-form-item label="用户名" prop="username">
        <el-input v-model="form.username" placeholder="请输入用户名" />
      </el-form-item>

      <!-- 密码 -->
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" type="password" placeholder="请输入密码" />
      </el-form-item>

      <!-- 确认密码 -->
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password" placeholder="请确认密码" />
      </el-form-item>

      <!-- 姓名 -->
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" />
      </el-form-item>

      <!-- 邮箱 -->
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入邮箱地址" />
      </el-form-item>

      <!-- 手机号码 -->
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号码" maxlength="11" />
      </el-form-item>

      <!-- 机构选择 -->
      <el-form-item label="机构" prop="organization">
        <el-select v-model="form.organization" placeholder="请选择机构">
          <el-option label="机构A" value="1" />
          <el-option label="机构B" value="2" />
          <el-option label="机构C" value="3" />
        </el-select>
      </el-form-item>

      <!-- 摄像头拍照 -->
      <el-form-item label="上传头像">
        <div class="camera-container">
          <video v-show="showCamera" ref="video" width="320" height="240" autoplay></video>
          <canvas ref="canvas" style="display:none;"></canvas>
          <img v-if="imageSrc" :src="imageSrc" alt="头像" class="preview-image" />

          <el-button type="primary" v-if="!isImageCaptured" @click="handleCapture">
            {{ showCamera ? '拍照' : '打开摄像头' }}
          </el-button>
          <el-button type="warning" v-if="isImageCaptured" @click="resetImage">重新上传</el-button>
        </div>
      </el-form-item>

      <!-- 提交和重置按钮 -->
      <el-form-item>
        <el-button type="primary" @click="onSubmit">注册</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';
import { ElMessage } from 'element-plus';
import axios from '@/axios';

export default {
  setup() {
    const formRef = ref(null);
    const form = reactive({
      username: '',
      password: '',
      confirmPassword: '',
      name: '',          // 姓名
      email: '',         // 邮箱地址
      phone: '',         // 手机号码
      organization: '',  // 机构选择
      avatar: ''         // 存储拍照的图片 Base64 数据
    });

    const rules = reactive({
      username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
      password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      confirmPassword: [{ required: true, message: '请确认密码', trigger: 'blur' }],
      name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
      email: [
        { required: true, message: '请输入邮箱地址', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请输入手机号码', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号码', trigger: 'blur' }
      ],
      organization: [{ required: true, message: '请选择机构', trigger: 'change' }]
    });

    const video = ref(null);
    const canvas = ref(null);
    const imageSrc = ref('');
    const showCamera = ref(false);
    const isImageCaptured = ref(false);

    const startCamera = () => {
      navigator.mediaDevices.getUserMedia({ video: true })
          .then((stream) => {
            if (video.value) {
              video.value.srcObject = stream;
              showCamera.value = true;
            }
          })
          .catch(() => ElMessage.error('无法访问摄像头'));
    };

    const captureImage = () => {
      if (canvas.value && video.value) {
        const context = canvas.value.getContext('2d');
        canvas.value.width = video.value.videoWidth;
        canvas.value.height = video.value.videoHeight;
        context.drawImage(video.value, 0, 0, canvas.value.width, canvas.value.height);
        const dataUrl = canvas.value.toDataURL('image/png');
        imageSrc.value = dataUrl;
        form.avatar = dataUrl;
        stopCamera();
        showCamera.value = false;
        isImageCaptured.value = true;
      }
    };

    const stopCamera = () => {
      if (video.value && video.value.srcObject) {
        video.value.srcObject.getTracks().forEach(track => track.stop());
        video.value.srcObject = null;
      }
    };

    const handleCapture = () => {
      if (!showCamera.value) startCamera();
      else captureImage();
    };

    const resetImage = () => {
      imageSrc.value = '';
      form.avatar = '';
      isImageCaptured.value = false;
      startCamera();
    };

    const onSubmit = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          axios.post('/login/register', form)
              .then((res) => {

                if(res.data.success) {
                  ElMessage.success('注册成功')
                }
                else {
                  ElMessage.error(res.data.errorMsg)
                }
              })
              .catch(() => ElMessage.error('注册失败'));
        }
        else ElMessage.error('请填写完整信息');
      });
    };

    const onReset = () => {
      formRef.value.resetFields();
      resetImage();
    };

    return {
      form,
      rules,
      video,
      canvas,
      imageSrc,
      showCamera,
      isImageCaptured,
      handleCapture,
      resetImage,
      onSubmit,
      onReset,
      formRef
    };
  }
};
</script>

<style>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(to right, #f093fb, #ffffff);
}

.register-form {
  background: #fff;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.register-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
}

.camera-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-image {
  margin-top: 10px;
  max-width: 100%;
  height: 300px;
  border-radius: 8px;
}

.el-input {
  border-radius: 8px;
}

.el-button--primary {
  background: #409eff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>
